import React from 'react'

import MaskedField from './MaskedField'

function FormCnpj(props) {
  return (
    <MaskedField mask="99.999.999/9999-99" {...props} />
  )
}

export default FormCnpj